// 经营信息
export default [
  {
    path: "/businessInformation",
    name: "businessInformation",
    meta: { title: "经营信息" },
    component: () => import("../views/businessInformation/index"),
    children: [
      {
        path: "/businessInformation/list",
        name: "businessInformationList",
        meta: { title: "轮播图管理", isMenu: true },
        component: () => import("../views/businessInformation/list"),
      },
      {
        path: "/businessInformation/list/details",
        name: "businessInformationDetails",
        meta: { title: "合作申请详情" },
        component: () => import("../views/businessInformation/detail/details"),
      },
      {
        path: "/businessInformation/company",
        name: "businessInformationCompany",
        meta: { title: "公司信息" },
        component: () => import("../views/businessInformation/company"),
      },
    ],
  },
]